import { AppBasicTable, AppResultsSkeleton } from '@components'
import { BI3DTableData, BIAggregationPrice, BIAsked, BIFormData, BIHeaders, BIIs3DTable, BIIsLoadingTable } from '../@signals'
import { excelSentence } from '../@services/sentence'
import { acrissProvidersHeaders, officeHeader } from './headers'
import React from 'react'
import { officeColumn, pricesColumn } from './columns'
import { Box, useTheme } from '@mui/material'
import BITableActions from '../@components/Table/Actions'
import { isLoadingCommonFilters } from '../../../../../@signals'
import { postExcel } from '@ui-seeker/utils'
import { BACKEND_APIS } from '../../../../../@constants'

export default function BI3DTable() {

    const { palette } = useTheme()

    if(!BIHeaders.value?.length || !BIIs3DTable.value) return null
    if (BIIsLoadingTable.value || isLoadingCommonFilters.value) return <AppResultsSkeleton/>


    return <AppBasicTable
        data={BI3DTableData.value?.[BIAggregationPrice.value]}
        // the question on screen, not the form being edited: its sentence is the Excel's first row (CU-869fmk5ge D3)
        onDownload={() => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, { ...(BIAsked.value?.form || BIFormData.value), querySentence: excelSentence(BIAsked.value, BIAggregationPrice.value) })}
        Components={{ Title: () => <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}><BITableActions/></Box> }}
        columns={[
            officeColumn(),
            ...BIHeaders.value?.map(((acriss, idx) => pricesColumn(acriss, palette, idx)))
        ]}
        headers={[[officeHeader(), ...BIHeaders.value.map(element => acrissProvidersHeaders(element))]]}
    />

}